/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// # User Product Price related scripts

define('modules/Product/ProductPrice',[
    'jquery',
    'global/all'
], function ($, Roc) {
    'use strict';

    function reloadProductPrice(viewModel) {
        $('*[data-element-type="productTitle"]').html(viewModel.name);
        // Customization: pricing is reloaded by DynamicProductPrice module (modules/Product/DynamicProductPrice)
        //Roc.UI.template('productPricingDetails-Tmp', viewModel.productPricing).then(function (renderedTemplate) {
        //    $('[data-roc-binding="pricing"]').html(renderedTemplate);
        //});

        //TODO: KITS

        if (viewModel.productType === 'Simple') {
            $('.itemSku').html('Part #: <span itemprop="sku">' + viewModel.sku + '</span>');
        } else {
            $('.itemSku').empty();
        }

        var $QuoteBtn = $('#QuoteBtn[href*=\'ProductId\']');
        if ($QuoteBtn.length > 0) {
            var href = $QuoteBtn.attr('href');
            $QuoteBtn.attr('href', href.substring(0, href.indexOf('=') + 1) + viewModel.id);
        }
    }

    function init() {
        Roc.EventManager.bind(Roc.Events.products.SELECTIONS_UPDATE, reloadProductPrice);
    }

    var ProductPrice = {
        init: init
    }

    Roc.Logger.debug('ProductPrice.js Loaded:', ProductPrice);

    return ProductPrice;
});
